export function getConstructiviqLoginUrl(): string {
  return window.location.origin;
}

export type UserInviteMessageType = "subscription" | "project";
export type UserInviteMessageFields = {
  firstName: string;
  email: string;
  password: string;
};

export function buildUserUnlockMessage(
  fields: UserInviteMessageFields
): string {
  const greetingName = fields.firstName.trim() || "there";

  return `Hello ${greetingName},

Your ConstructivIQ account has been unlocked.

Sign in: ${getConstructiviqLoginUrl()}
Email: ${fields.email}
New password: ${fields.password}

Please reset your password the first time you log in.

ConstructivIQ`;
}

export function buildUserInviteMessage(
  type: UserInviteMessageType,
  fields: UserInviteMessageFields
): string {
  const intro =
    type === "subscription"
      ? "Your ConstructivIQ account is ready."
      : "You have been added to a ConstructivIQ project.";

  const greetingName = fields.firstName.trim() || "there";

  return `Hello ${greetingName},

${intro}

Sign in: ${getConstructiviqLoginUrl()}
Email: ${fields.email}
Temporary password: ${fields.password}

Please reset your password the first time you log in.

ConstructivIQ`;
}

export async function copyTextToClipboard(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}
